import {Pipe, PipeTransform} from '@angular/core';
import {LocationDto} from '../../Models/Core/location.interface';

@Pipe({
  name: 'locations',
  standalone: false
})
export class LocationsPipe implements PipeTransform {

  transform(items: LocationDto[], local?: number, type?: number): LocationDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (local) {
      items = items.filter(item => item['id_local'] === local);
    }

    if (type) {
      items = items.filter(item => item['id_tipo'] === type);
    }

    return items;

  }

}
